import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#338AF3",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FFDA44",
  d: "M18.784 12.13H5.219c0 .937.815 1.696 1.752 1.696h-.057c0 .936.76 1.695 1.696 1.695 0 .937.76 1.696 1.696 1.696h3.391c.937 0 1.696-.759 1.696-1.696.936 0 1.695-.759 1.695-1.695h-.056c.936 0 1.752-.76 1.752-1.696"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#338AF3",
  d: "M16.696 9.914a4.696 4.696 0 0 1-9.391 0"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FFDA44",
  d: "m15.587 9.912-1.465.69.78 1.42-1.591-.305-.202 1.607-1.108-1.182-1.109 1.182-.201-1.607-1.592.304.78-1.42-1.465-.689 1.466-.689-.78-1.42 1.59.305.202-1.608 1.109 1.183L13.109 6.5l.202 1.608 1.591-.304-.78 1.42z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }